import { render, staticRenderFns } from "./ActiveAlerts.html?vue&type=template&id=46ddaa7e&scoped=true&external"
import script from "./ActiveAlerts.js?vue&type=script&lang=js&external"
export * from "./ActiveAlerts.js?vue&type=script&lang=js&external"
import style0 from "./ActiveAlerts.scss?vue&type=style&index=0&id=46ddaa7e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ddaa7e",
  null
  
)

export default component.exports